export const NEW_USER = "NEW_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_MONTH_YEAR = "SET_MONTH_YEAR";
export const RESET_MONTH = "RESET_MONTH";
export const LOAD_STATUS = "LOAD_STATUS";
export const LOAD_STATUS_SUCCESS = "LOAD_STATUS_SUCCESS";
export const LOAD_STATUS_FAILURE = "LOAD_STATUS_FAILURE";
